import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository';
import { SpoolDownload,FileDownloadpath } from '../../Model/spooldownload/spooldownload.model';
import { Observable, throwError } from 'rxjs';
import { HttpParams, HttpErrorResponse } from "@angular/common/http";
import { map, filter, catchError, mergeMap } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class SpoolDownloadService {
  constructor(
    private _repositoryService: ServiceRepository
  ) { }


  getSpoolDownloadList(userId: string): Observable<SpoolDownload[]> {
    let params = new HttpParams();
   
    return this._repositoryService.getAll<SpoolDownload[]>(  
    '/api/Download/DownloadFilesList/' + userId ,params)
      .pipe(
        map(data => data.map(data => new SpoolDownload().deserialize(data))),
        catchError( error => {
          return throwError( error );
        })
      )
  }

  getFile(userId: string,filepath: FileDownloadpath){
    return this._repositoryService
    .downloadfile('/api/Download/DownloadExtFile/' + userId , filepath)   
    
  }

  getUserDownloadAccess(userId: string) {
    return this._repositoryService
    .getDatawitHeaders('/api/Download/CanDownload/' + userId )   
    
  }
  


}
